/**
 * @generated SignedSource<<5ab2b9ff60b87308e15416890bb3534f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type HubspotCardQuery$variables = {
  emails: ReadonlyArray<string>;
};
export type HubspotCardQuery$data = {
  readonly hubspotContactsForEmails: ReadonlyArray<{
    readonly __typename: "HubspotContactPanelNode";
    readonly company: {
      readonly id: string;
      readonly name: string;
      readonly url: string;
    } | null;
    readonly deals: ReadonlyArray<{
      readonly amount: string | null;
      readonly id: string;
      readonly name: string;
      readonly url: string;
    }>;
    readonly email: string;
    readonly id: string;
    readonly name: string;
    readonly tickets: ReadonlyArray<{
      readonly description: string | null;
      readonly id: string;
      readonly subject: string | null;
      readonly url: string;
    }>;
    readonly title: string | null;
    readonly url: string;
  }> | null;
};
export type HubspotCardQuery = {
  response: HubspotCardQuery$data;
  variables: HubspotCardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "emails"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "emails",
        "variableName": "emails"
      }
    ],
    "concreteType": "HubspotContactPanelNode",
    "kind": "LinkedField",
    "name": "hubspotContactsForEmails",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "HubspotCompanyNode",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "HubspotDealNode",
        "kind": "LinkedField",
        "name": "deals",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "amount",
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "HubspotTicketNode",
        "kind": "LinkedField",
        "name": "tickets",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subject",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HubspotCardQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HubspotCardQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "6a3da910dc563fac047192ef90bf3a88",
    "id": null,
    "metadata": {},
    "name": "HubspotCardQuery",
    "operationKind": "query",
    "text": "query HubspotCardQuery(\n  $emails: [String!]!\n) {\n  hubspotContactsForEmails(emails: $emails) {\n    __typename\n    id\n    url\n    name\n    email\n    title\n    company {\n      id\n      url\n      name\n    }\n    deals {\n      id\n      url\n      amount\n      name\n    }\n    tickets {\n      id\n      url\n      subject\n      description\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "df5d82602f0a5e54200fe19f203861d9";

export default node;
